import React from 'react';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

import styles from './index.css';

export class SortColumn extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            direction: this.props.direction
        };

        this.sort = this.sort.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.direction !== this.props.direction) {
            this.setState({ direction: this.props.direction });
        }
    }

    get direction() {
        if (this.props.sort !== this.props.activeSort) {
            return 'asc';
        } else if (this.state.direction === 'asc') {
            return 'desc';
        }

        return 'asc';
    }

    get isSorted() {
        return this.props.sort !== undefined && this.props.sort === this.props.activeSort;
    }

    sort() {
        this.setState({ direction: this.direction }, () => {
            if (this.props.onSort) this.props.onSort(this.props.sort, this.state.direction);
        });
    }

    render() {
        return (
            <div className={styles.root} disabled={this.props.disabled} onClick={this.sort} style={this.props.style}>
                {this.props.children}
                {this.isSorted && (
                    <div className={`${styles.icon} ${styles[this.state.direction]}`}>
                        <ArrowUpwardIcon></ArrowUpwardIcon>
                    </div>
                )}
            </div>
        )
    }
}
